import { render } from "./ActivityFormPanelReminder.vue?vue&type=template&id=5cdb3954&scoped=true"
import script from "./ActivityFormPanelReminder.vue?vue&type=script&lang=js"
export * from "./ActivityFormPanelReminder.vue?vue&type=script&lang=js"

import "./ActivityFormPanelReminder.vue?vue&type=style&index=0&id=5cdb3954&scoped=true&lang=scss"
import "./ActivityFormPanelReminder.vue?vue&type=style&index=1&id=5cdb3954&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cdb3954"]])

export default __exports__